import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DayPicker from 'react-datepicker';
import { getProductTypeName } from "../../utils";

import DatePickerContainer from './styles';

const mapStateToProps = state => ({
  date: state.userPreferences.date,
});

@connect(mapStateToProps)
class DatePicker extends Component {
  static propTypes = {
    handleDayClick: PropTypes.func,
    handleDateChange: PropTypes.func,
    calendarData: PropTypes.instanceOf(Object),
    needShowPasses: PropTypes.bool,
    date: PropTypes.string,
    selectedDate: PropTypes.string,
    productType: PropTypes.number,
    monthsShown: PropTypes.number,
  };

  static defaultProps = {
    monthsShown: 1,
  };

  constructor(props) {
    super(props);
    const { selectedDate, date, needShowPasses } = props;
    const { calculateUnavailableDate } = this;

    const lookingAt = moment(date).format('YYYY-MM-DD');

    this.state = {
      day: moment(selectedDate).toDate(),
      lookingAt,
      slicedUnavailableDates: needShowPasses ? calculateUnavailableDate(lookingAt) : [],
    };
  }

  componentDidMount() {
    const { renderAvailablePlaces } = this;
    const { needShowPasses } = this.props;

    if (needShowPasses) renderAvailablePlaces();
  }

  componentDidUpdate(prevProps, prevState) {
    const { renderAvailablePlaces, calculateUnavailableDate } = this;
    const { lookingAt: wasLookingAt } = prevState;
    const { lookingAt: nowLookingAt } = this.state;
    const { needShowPasses } = this.props;

    if (needShowPasses && wasLookingAt !== nowLookingAt) {
      renderAvailablePlaces();

      this.setState({
        slicedUnavailableDates: calculateUnavailableDate(nowLookingAt),
      })
    }
  }

  renderAvailablePlaces = () => {
    const { lookingAt } = this.state;
    const { calendarData, productType } = this.props;
    const { capacity, capacityByDay } = calendarData;

    const monthDays = Array.from(document.querySelectorAll('.react-datepicker__day:not(.react-datepicker__day--outside-month):not(.react-datepicker__day--disabled)'));
    const outMonthDays = Array.from(document.querySelectorAll('.react-datepicker__day.react-datepicker__day--outside-month'));
    const formattedArrayOutOfMonth = outMonthDays.reduce(
      (acc, curr) => {
        let month = 0;
        if(curr.innerText < 20){
          month = 1;
        } else {
          month = -1;
        }
        return {
        ...acc,
        [moment(`${moment(lookingAt).format('YYYY-MM')}-${curr.innerText}`).add(month,'month').format('YYYY-MM-DD')]: curr,
      }}, {}
    );

    const formattedArray = monthDays.reduce(
      (acc, curr) => ({
        ...acc,
        [moment(`${moment(lookingAt).format('YYYY-MM')}-${curr.innerText}`).format('YYYY-MM-DD')]: curr,
      }), {}
    );

    const unitedMonth = {...formattedArray, ...formattedArrayOutOfMonth};

    Object.keys(unitedMonth).map(date => {
      const weekDay = moment(date).day();
      const currDateCap = capacity[date];

      const tickets = currDateCap || capacityByDay[weekDay];
      if (tickets){
        return unitedMonth[date].setAttribute(
          'amount-pass',
          `${tickets} ${getProductTypeName(productType, tickets).toLowerCase()} left`,
        );
      }else{
        return unitedMonth[date].setAttribute(
          'amount-pass',
          `0 ${getProductTypeName(productType, 0).toLowerCase()} left`,
        );
      }
    });
  };

  calculateUnavailableDate = lookingAt => {
    const { getDatesBetween } = this;
    const { calendarData } = this.props;
    const { unavailableDates, capacityByDay, capacity } = calendarData;

    const startOfMonth = moment(lookingAt).startOf('month');
    const startOfMonthWithWeek = moment(startOfMonth).subtract(10, 'day').format('YYYY-MM-DD');
    const endOfMonth = moment(lookingAt).endOf('month');
    const endOfMonthWithWeek = moment(endOfMonth).add(10, 'day').format('YYYY-MM-DD');
    const slicedUnavailableDates = unavailableDates.filter(date => moment(date).isBetween(startOfMonthWithWeek, endOfMonthWithWeek, null, '[]')).map(day => moment(day).toDate());

    const additionalUnavailableDates = getDatesBetween(startOfMonthWithWeek, endOfMonthWithWeek).filter(date => {
      const weekDay = moment(date).day();
      return capacityByDay[weekDay] === 0 && !capacity[date];
    }).map(day => moment(day).toDate());

    return [...new Set([...slicedUnavailableDates, ...additionalUnavailableDates])];
  };

  getDatesBetween = (startDate, endDate) => {
    let now = startDate;
    const dates = [];

    while (moment(now).isSameOrBefore(endDate)) {
      dates.push(moment(now).format('YYYY-MM-DD'));
      now = moment(now).add(1, 'day');
    }

    return dates;
  };

  onDayClick = day => {
    const { handleDayClick, handleDateChange, needShowPasses } = this.props;
    handleDayClick(moment(day).format('YYYY-MM-DD'));

    if (needShowPasses && handleDateChange) handleDateChange(moment(day).format('YYYY-MM-DD'));

    this.setState({ day });
  };

  handleMonthChange = (date) => {
    this.setState(
      {
        lookingAt: moment(date).format('YYYY-MM-DD')
      }
    )
  };

  render() {
    const { handleMonthChange } = this;
    const { day, slicedUnavailableDates } = this.state;
    const { needShowPasses, monthsShown } = this.props;

    return (
      <DatePickerContainer monthsShown={monthsShown} needShowPasses={needShowPasses}>
        <DayPicker
          monthsShown={monthsShown}
          dropdownMode="select"
          inline
          onSelect={this.onDayClick}
          selected={new Date(day)}
          excludeDates={slicedUnavailableDates}
          minDate={new Date()}
          onMonthChange={handleMonthChange}
        />
      </DatePickerContainer>
    );
  }
}

export default DatePicker;
